import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TDPTableSelectRedux from '../../TDP/TDPTableSelectRedux';
import TurmaDisciplinaProfessorProfileRedux from '../../TDP/TurmaDisciplinaProfessorProfileRedux';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import PAAlunoTable from './PAAlunoTable';
import PAResumoTable from './PAResumoTable';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const useStyles = makeStyles({
    paper: {

        padding: '20px',
        backgroundColor: '##fff',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    tabMenu: {
        marginTop: '20px'
    }
});

export default function PAAlunoContainer() {
    const classes = useStyles();
    const tdp = useSelector(state => state.tdp);
    const [menuShow, setMenuShow] = useState(0);


    const handleChange = (event, newValue) => {
        setMenuShow(newValue);
    };

    return (
        <Container className={classes.paper} component={Paper}>
            <Grid container justifyContent="space-between">
                <Grid size={3}>
                    <Typography className={classes.title} variant="h5">
                        Presenças
                    </Typography>
                </Grid>
            </Grid>
            {tdp ?
                <>
                    <TurmaDisciplinaProfessorProfileRedux />
                    <Grid className={classes.tabMenu} container justifyContent="center">
                        <Grid size={6}>
                            <Paper style={{
                                backgroundColor: 'rgb(146 89 167)'
                            }}>
                                <Tabs
                                    value={menuShow}
                                    onChange={handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    centered
                                >
                                    <Tab style={{ color: 'white' }} label="Tabela" />
                                    <Tab style={{ color: 'white' }} label="Resumo" />
                                </Tabs>
                            </Paper>
                        </Grid>
                    </Grid>

                    {menuShow === 0 ? <PAAlunoTable /> : ''}
                    {menuShow === 1 ? <PAResumoTable /> : ''}

                </> :
                <TDPTableSelectRedux />
            }
        </Container>
    );
}